export class Servicio {
    servicioId: string;
    nombre: string;
    precio: number;
    exento: boolean;
    activo: boolean;
    fechaCreacion: Date;
    fechaModificacion?: Date;
    usuarioCreo: string;
    usuarioModifico?: string;
    emisorId: string;
    sucursalId: string;
    showActions?: boolean;
}
